export const GET_DATA = 'requirementLaborResources/GET_DATA'
export const GET_DATA_DONE = 'requirementLaborResources/GET_DATA_DONE'
export const GET_DATA_FAIL = 'requirementLaborResources/GET_DATA_FAIL'